export default __webpack_public_path__ + "static/media/kitchen3-afterJ-2048w.537403fa.png";